import { render, staticRenderFns } from "./CommonButton.vue?vue&type=template&id=22e33d75&scoped=true&"
import script from "./CommonButton.vue?vue&type=script&lang=js&"
export * from "./CommonButton.vue?vue&type=script&lang=js&"
import style0 from "./CommonButton.vue?vue&type=style&index=0&id=22e33d75&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e33d75",
  null
  
)

export default component.exports